import {
  ProductSalesModel,
  useCreateProductSale,
} from 'api-hooks/product/sales';
import { Notification, KIND } from 'baseui/notification';
import { NavigationRoutes } from 'common/constants';
import useApprovalableEdit from 'hooks/use-approvalable-edit';
import { SeparatorVertical } from 'legacy-modules/styles';
import * as React from 'react';
import { NavigationProps } from 'types';

import ProductSaleForm from './components/form';
import { ProductSaleFormType } from './components/form-type';

export type ProductSaleCreateParams = {
  defaultValues?: ProductSaleFormType;
  productSale?: ProductSalesModel;
};

export default function ProductSaleCreate(
  props: NavigationProps<NavigationRoutes.ProductSalesCreate>,
) {
  const { mutateAsync, error } = useCreateProductSale();

  const defaultValues = props.navigation.params?.defaultValues;

  const onResolve = useApprovalableEdit('product-sales');

  return (
    <>
      <ProductSaleForm
        {...props}
        defaultValues={defaultValues}
        renderError={
          !!error &&
          !!error.message && (
            <>
              <Notification
                overrides={{
                  Body: { style: { width: 'auto', wordBreak: 'break-all' } },
                }}
                kind={KIND.negative}
                closeable
              >
                {() => error.message}
              </Notification>
              <SeparatorVertical $margin={8} />
            </>
          )
        }
        onSubmit={async (input, form) => {
          const result = await mutateAsync(input);
          onResolve(result);
          return result.data;
        }}
      />
    </>
  );
}
